import { useEffect, useMemo,useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from "react-router-dom";

import config from "@/config";
import useIsFirstRender from "@/hooks/useIsFirstRender";
import HomeArtists from "@/pages/home/artists";
import HomeArtlists from "@/pages/home/artlists";
import HomeArtworks from "@/pages/home/artworks";
import HomeGalleries from "@/pages/home/galleries";
import HomeUsers from "@/pages/home/users";
// import QuestionsIcon from "@/shared-components/icons/components/public/QuestionsIcon";
// import OrderByPopup from '@/shared-components/popups/components/OrderByPopup';
// import Text from "@/shared-components/text/components/Text";
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

// import FiltersRenderer from "./components/FiltersRenderer";
import Searchbar from "./components/Searchbar";
import PreSearch from "./pre-search";
// import SearchFilters from "./search-filters";
import SearchResults from "./search-results";

import './index.css';

export default function Search() {
  const location = useLocation();
  const navigate = useNavigate();
  const [query, setQuery] = useState(location.state ? location.state : { sort: config.search.main_search.artwork_order_by[0] });
  // const [openFilters, setOpenFilters] = useState(false);
  // const [setOpenFilters] = useState(false);
  const isFirstRender = useIsFirstRender();
  // const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [selectedCategory, setSelectedCategory] = useState('Artworks');

  const handleSelectedCategoryChange = (index) => {
    setSelectedCategory(index);
  };
  
  const isPreSearch = useMemo(() => (
    Object.keys(query).filter(key => {
      if(key !== "sort" && query[key]) {
        if(Array.isArray(query[key])) { 
          return query[key].length > 0;
        } else {
          return true;
        }
      } else return false;
    }).length === 0
  ), [query]);

  useEffect(() => {
    const handleResize = () => {
      // setIsMobile(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window]);

  useEffect(() => {
    /** Previously i used search params to store the query data (in order to restore it when we enter again to the search paage) 
         * but the url got way too long. That's why we will store it in the state of the url. The user will have a very short url (readable) */
    if(!isFirstRender) { 
      navigate("/search", { state: query, replace: true });
    }
  }, [query]);

  useEffect(()=>{
    setTimeout(() => {
      document.body.classList.add("search-scrollbar");
    }, 50); /** Timeout prevents scrollbar from appearing on init */

    return () => {
      document.body.classList.remove("search-scrollbar");
    };
  }, []);

  // function getListLength() {
  //   let length = 0;
  //   length = query.artist ? length + query.artist.length : length;
  //   length = query.theme ? length + query.theme.length : length;
  //   length = query.emotion ? length + query.emotion.length : length;
  //   length = query.medium ? length + query.medium.length : length;
  //   length = query.color ? length + query.color.length : length;
  //   length = query.gallery ? length + query.gallery.length : length;
  //   length = query.size ? length + 1 : length;
  //   length = query.price ? length + 1 : length;
  //   length = query.limitedEditions === true ? length + 1 : length;
  //   return length;
  // }

  return (
    <>
      <Helmet>
        <title>Search | Find paintings on Suarte</title>
        <meta
          name="description"
          content="Explore and connect with exclusive, top-tier artworks from global galleries and their represented artists. Utilize advanced filters and enjoy finding your soulmate."
        />
        <link rel="canonical" href={"https://suarte.art/search"} />
      </Helmet>
      <AppNavigationPage>
        <div className="search__page">
          {/* <div className="search__filters">
            <SearchFilters 
              query={query} 
              setQuery={setQuery} 
              open={openFilters} 
              close={()=>setOpenFilters(false)}
            />
          </div> */}

          <main className="search__main">
            <div className="search__sticky-main">
              <Searchbar query={query} setQuery={setQuery} categorySelected={handleSelectedCategoryChange}/>

              {/* <FiltersRenderer 
                query={query} 
                setQuery={setQuery} 
                exceptions={["sort", "q"]}
              /> */}

              <div 
                // className={`search__options-container element-non-selectable ${isPreSearch ? "pre" : ""}`} 
                className={`search__options-container element-non-selectable`} 
              >
                {/* <Text className="search__option" small onClick={()=>setOpenFilters(true)} style={((isMobile <= 900) && getListLength() > 0) ? { marginBottom: "50px", marginTop: "-70px" } : {}}>
                  Artwork filters <QuestionsIcon/>
                </Text> */}

                {/* {!isPreSearch && (
                  <OrderByPopup 
                    onChangeOption={(option)=>setQuery({ ...query, sort: option })} 
                    defaultOption={query.sort}
                    options={config.search.main_search.artwork_order_by}
                  />
                )} */}
              </div>

            </div>
            {
              selectedCategory === 'Artworks' ?
                <HomeArtworks fromSearch={true} valueFromSearch={query} />
                : selectedCategory === 'Galleries' ?
                  <HomeGalleries fromSearch={true} valueFromSearch={query} />
                  : selectedCategory === 'Artists' ?
                    <HomeArtists fromSearch={true} valueFromSearch={query} />
                    : selectedCategory === 'Users' ?
                      <HomeUsers fromSearch={true} valueFromSearch={query} />
                      : selectedCategory === 'Artlists' ?
                        <HomeArtlists fromSearch={true} valueFromSearch={query} />
                        :

                        isPreSearch ? 
                          <PreSearch/> 
                          : 
                          <SearchResults query={query}/>
            }
          </main>
        </div>
      </AppNavigationPage>
    </>
  );
}
